import { EvidencesConfig } from "../../../pages/reportFolio/pages/dashboard/typing"
import { Evidence } from "../../../service/reportFolio/response"
import { EvidencesTypeValueEnum } from "../../../utils/enums/evidences"
import { EvidenceStateValue } from "../types"
export type FormatEvidenceData = {
    requireList: Record<string, boolean>
    evidence: EvidenceStateValue
}

const imagesList = [EvidencesTypeValueEnum?.IMAGE, EvidencesTypeValueEnum?.CAMERA], videoList = [EvidencesTypeValueEnum?.VIDEO, EvidencesTypeValueEnum?.VIDEO_GALLERY]
export const formatEvidenceToUploadItems = ({ evidenceList, evidences }: { evidenceList: EvidencesConfig[]; evidences?: Evidence[] }): FormatEvidenceData => {
    let evidenceFormat: EvidenceStateValue = {}, evidenceRequiredList: Record<string, boolean> = {}

    evidenceList?.forEach((item) => {
        if (!!item?.isRequired) {
            const existSomeEvidence = !!evidences?.some(evidence => evidence.evidenceTypeId == item.evidence)
            evidenceRequiredList = { ...evidenceRequiredList, [item.evidence]: existSomeEvidence }
        }

        if (imagesList.includes(item.evidence)) {
            if (item.evidence == EvidencesTypeValueEnum?.IMAGE || (item.evidence == EvidencesTypeValueEnum?.CAMERA /* && !!item?.isRequired */)) {
                const imageValue = evidenceFormat?.[item.evidence]
                evidenceFormat = {
                    ...evidenceFormat,
                    [item.evidence]: {
                        minAmount: !!item?.isRequired ? 1 : 0,
                        accept: imageValue?.accept ? `${imageValue?.accept},${item.type?.join(',.')}` : `.${item.type?.join(',.')}`,
                        maxCount: (imageValue?.maxCount ?? 0) + item.amount,
                        size: item.size,
                        typeEvidence: {
                            ...(imageValue?.typeEvidence ?? {}),
                            [item.evidence]: {
                                isRequired: !!item?.isRequired,
                                type: item.evidence,
                                amount: item.amount,
                            },
                        },
                    },
                }
            }
        } else if (videoList.includes(item.evidence)) {
            if (item.evidence == EvidencesTypeValueEnum?.VIDEO_GALLERY || (item.evidence == EvidencesTypeValueEnum?.VIDEO /* && !!item?.isRequired */)) {
                const videoValue = evidenceFormat?.[item.evidence]

                evidenceFormat = {
                    ...evidenceFormat,
                    [item.evidence]: {
                        customeTitle: item.customeTitle,
                        minAmount: !!item?.isRequired ? 1 : 0,
                        accept: videoValue?.accept ? `${videoValue?.accept},${item.type?.join(',.')}` : `.${item.type?.join(',.')}`,
                        maxCount: (videoValue?.maxCount ?? 0) + item.amount,
                        size: item.size,
                        typeEvidence: {
                            ...(videoValue?.typeEvidence ?? {}),
                            [item.evidence]: {
                                isRequired: !!item?.isRequired,
                                type: item.evidence,
                                amount: item.amount,
                            },
                        },
                    },
                }
            }
        } else {
            evidenceFormat = {
                ...evidenceFormat,
                [item.evidence]: {
                    minAmount: !!item?.isRequired ? 1 : 0,
                    accept: !!item.type?.length ? `.${item.type?.join(',.')}` : undefined,
                    maxCount: (evidenceFormat?.[item.evidence ?? '']?.maxCount ?? 0) + item.amount,
                    size: item.size,
                    typeEvidence: {
                        [item.evidence]: {
                            isRequired: !!item?.isRequired,
                            type: item.evidence,
                            amount: item.amount,
                        },
                    },
                },
            }
        }
    })

    return { evidence: evidenceFormat, requireList: evidenceRequiredList }
}